import React from 'react';
import { XIcon, CheckIcon, ArrowRightIcon } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function TransformationSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  const beforeItems = ['Te acuestas con miedo a otra noche en vela', 'Despiertas a las 3 AM con el corazón acelerado', 'Arrastras neblina mental todo el día', 'Te sientes irritable y sin paciencia', 'Tu cuerpo envejece más rápido por falta de descanso reparador'];
  const afterItems = ['Te acuestas tranquila, sabiendo que tienes un plan', 'Duermes de corrido y despiertas naturalmente', 'Tu mente está clara, enfocada y presente', 'Tienes energía y buen humor desde la mañana', 'Tu cuerpo se regenera cada noche como debe ser'];
  return <section className="relative py-24 px-6 z-10 bg-night-900" data-id="element-259">
      <div ref={ref} className={`max-w-5xl mx-auto section-reveal ${isVisible ? 'visible' : ''}`} data-id="element-260">
        <h3 className="text-3xl md:text-5xl font-heading font-bold text-cream-100 mb-16 text-center leading-tight" data-id="element-261">
          Imagina cómo será tu vida en solo 7 días
        </h3>

        <div className="grid md:grid-cols-[1fr_auto_1fr] gap-8 items-center" data-id="element-262">
          {/* AHORA Card */}
          <div className="glass-card p-8 md:p-10 rounded-3xl border-t-4 border-t-red-900/50 bg-night-900/80 relative overflow-hidden" data-id="element-263">
            <div className="absolute inset-0 bg-red-900/5 pointer-events-none" data-id="element-264" />
            <h4 className="text-2xl font-heading font-bold text-cream-200/60 mb-8 tracking-widest uppercase text-center" data-id="element-265">
              AHORA
            </h4>
            <ul className="space-y-6 relative z-10" data-id="element-266">
              {beforeItems.map((item, i) => <li key={i} className="flex items-start" data-id="element-267">
                  <div className="flex-shrink-0 mt-1" data-id="element-268">
                    <XIcon className="w-5 h-5 text-red-400/60" data-id="element-269" />
                  </div>
                  <p className="ml-4 text-cream-200/70 text-lg leading-relaxed" data-id="element-270">
                    {item}
                  </p>
                </li>)}
            </ul>
          </div>

          {/* Arrow Separator (Desktop only) */}
          <div className="hidden md:flex flex-col items-center justify-center" data-id="element-271">
            <div className="w-16 h-16 rounded-full bg-night-800 border border-gold-500/20 flex items-center justify-center shadow-[0_0_30px_rgba(212,168,83,0.15)]" data-id="element-272">
              <ArrowRightIcon className="w-8 h-8 text-gold-400" data-id="element-273" />
            </div>
          </div>

          {/* CON EL MÉTODO Card */}
          <div className="glass-card p-8 md:p-10 rounded-3xl border border-gold-500/30 bg-night-800/90 relative overflow-hidden shadow-[0_0_40px_rgba(212,168,83,0.1)] transform md:scale-105" data-id="element-274">
            <div className="absolute inset-0 bg-gold-500/5 pointer-events-none" data-id="element-275" />
            <div className="absolute -top-24 -right-24 w-48 h-48 bg-gold-500/10 blur-3xl rounded-full pointer-events-none" data-id="element-276" />

            <h4 className="text-2xl font-heading font-bold text-gold-400 mb-8 tracking-widest uppercase text-center relative z-10" data-id="element-277">
              CON EL MÉTODO S.C.A.
            </h4>
            <ul className="space-y-6 relative z-10" data-id="element-278">
              {afterItems.map((item, i) => <li key={i} className="flex items-start" data-id="element-279">
                  <div className="flex-shrink-0 mt-1" data-id="element-280">
                    <CheckIcon className="w-6 h-6 text-gold-400" data-id="element-281" />
                  </div>
                  <p className="ml-4 text-cream-100 text-lg leading-relaxed font-medium" data-id="element-282">
                    {item}
                  </p>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}